module.exports = __webpack_public_path__ + "static/img/4.8d24771.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/zh/4.png
// module id = FQnH
// module chunks = 0